(function(){
var D=document;
// intro del cierre: solo una vez por sesion
try{ if(sessionStorage.getItem('dc_zip')){var z=D.getElementById('dc-zip'); if(z) z.parentNode.removeChild(z);} else {sessionStorage.setItem('dc_zip','1');} }catch(e){}

function openCart(){D.body.classList.add('dc-open');}
function closeCart(){D.body.classList.remove('dc-open');}
D.addEventListener('click',function(e){
  var o=e.target.closest('[data-dc-cart]'); if(o){e.preventDefault();openCart();return;}
  var c=e.target.closest('[data-dc-close]'); if(c){e.preventDefault();closeCart();return;}
  var r=e.target.closest('[data-dc-remove]');
  if(r){e.preventDefault();change(r.getAttribute('data-dc-remove'),0);return;}
});
D.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});

function refresh(open){
  return fetch('/?sections=cart-drawer').then(function(r){return r.json();}).then(function(j){
    var host=D.getElementById('shopify-section-cart-drawer');
    if(host&&j['cart-drawer']){host.innerHTML=j['cart-drawer'];}
    return fetch('/cart.js').then(function(r){return r.json();});
  }).then(function(cart){
    D.querySelectorAll('[data-dc-count]').forEach(function(el){el.textContent=cart.item_count;});
    if(open)openCart();
  }).catch(function(){});
}
function change(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){refresh(true);});
}

// ---- PDP ----
var pdp=D.getElementById('dc-pdp');
if(pdp){
  var chips=pdp.querySelectorAll('[data-dc-variant]');
  var idInput=pdp.querySelector('[name="id"]');
  var err=pdp.querySelector('[data-dc-sizeerr]');
  var priceEl=pdp.querySelectorAll('[data-dc-price]');
  var oldEl=pdp.querySelectorAll('[data-dc-old]');
  var buyLabel=pdp.querySelectorAll('[data-dc-buylabel]');
  var waBtns=pdp.querySelectorAll('[data-dc-wa]');
  var waNum=pdp.getAttribute('data-dc-wanum')||'';
  var waShop=pdp.getAttribute('data-dc-washop')||'';
  var waTitle=pdp.getAttribute('data-dc-watitle')||'';
  var waUrl=pdp.getAttribute('data-dc-waurl')||'';
  function waUpdate(size,price){
    if(!waBtns.length||!waNum)return;
    var m='\u00a1Hola! \ud83d\udc4b Quiero comprar este producto de '+waShop+' y me gustar\u00eda que me asesoren:\n'
      +'\ud83d\udecd\ufe0f Producto: '+waTitle+'\n'
      +(size?'\ud83d\udccf Talla: '+size+'\n':'')
      +(price?'\ud83d\udcb0 Precio: '+price+'\n':'')
      +'\ud83d\udd17 '+waUrl+'\n'
      +'\u00bfMe confirman disponibilidad y c\u00f3mo hago el pedido? \ud83d\ude4c';
    var href='https://wa.me/'+waNum+'?text='+encodeURIComponent(m);
    waBtns.forEach(function(a){a.setAttribute('href',href);});
  }
  function pick(btn){
    chips.forEach(function(b){b.style.background='#fff';b.style.color='#16164e';b.style.borderColor='#d6deeb';});
    btn.style.background='#16164e';btn.style.color='#fff';btn.style.borderColor='#16164e';
    if(idInput)idInput.value=btn.getAttribute('data-dc-variant');
    var p=btn.getAttribute('data-dc-pricefmt'); var o=btn.getAttribute('data-dc-oldfmt');
    if(p){priceEl.forEach(function(el){el.textContent=p;});buyLabel.forEach(function(el){el.textContent='COMPRAR — '+p;});}
    oldEl.forEach(function(el){ if(o){el.textContent=o;el.style.display='';} else {el.style.display='none';} });
    if(err){err.textContent='';}
    waUpdate(chips.length>1?btn.textContent.trim():'',p||'');
    pdp.setAttribute('data-picked','1');
    try{var u=new URL(window.location.href);u.searchParams.set('variant',btn.getAttribute('data-dc-variant'));history.replaceState({},'',u.toString());}catch(e){}
  }
  chips.forEach(function(b){b.addEventListener('click',function(){pick(b);});});
  var pre=pdp.querySelector('[data-dc-variant][data-dc-selected="1"]');
  if(pre)pick(pre);
  // miniaturas
  var main=pdp.querySelector('[data-dc-main]');
  pdp.querySelectorAll('[data-dc-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var src=t.getAttribute('data-dc-thumb');
      if(main)main.style.backgroundImage="url('"+src+"')";
      pdp.querySelectorAll('[data-dc-thumb]').forEach(function(x){x.style.borderColor='#ececf2';});
      t.style.borderColor='#16164e';
    });
  });
  // agregar al carrito
  pdp.querySelectorAll('[data-dc-add]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      if(chips.length>1&&pdp.getAttribute('data-picked')!=='1'){
        if(err)err.textContent='— SELECCIONA UNA TALLA';
        var sw=pdp.querySelector('[data-dc-sizes]'); if(sw){sw.scrollIntoView({behavior:'smooth',block:'center'});sw.querySelectorAll('[data-dc-variant]').forEach(function(b){b.style.borderColor='#e01e5c';});}
        return;
      }
      var vid=idInput?idInput.value:btn.getAttribute('data-dc-add');
      var old=btn.innerHTML; btn.style.opacity='0.7';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){window.location.href='/checkout';})
        .catch(function(){btn.style.opacity='1';window.location.href='/cart';});
    });
  });
  // contador de oferta
  var cds=pdp.querySelectorAll('[data-dc-countdown]');
  if(cds.length){
    var tick=function(){
      var now=new Date();var end=new Date(now);end.setHours(23,59,59,999);
      var t=Math.max(0,Math.floor((end-now)/1000));
      var p=function(n){return String(n).padStart(2,'0');};
      var s=p(Math.floor(t/3600))+':'+p(Math.floor(t/60)%60)+':'+p(t%60);
      cds.forEach(function(el){el.textContent=s;});
    };
    tick();setInterval(tick,1000);
  }
}
// autoplay del video del hero
var v=D.querySelector('video[data-dc-hero]');
if(v){var play=function(){v.muted=true;v.play().catch(function(){});};play();setInterval(play,1500);}
})();